import React from 'react';
import {WindowSideBarInfoPanel} from "mirador/dist/es/src/components/WindowSideBarInfoPanel";

/**
 * RemoveCanvasInfoPlugin
 * This plugin ensures that canvasIds is always an empty array.
 * It will prevent any CanvasInfo sections from being rendered in the WindowSideBarInfoPanel.
 */
const RemoveCanvasInfoPlugin = (props) => {
    const modifiedProps = {...props, canvasIds: []};
    return <WindowSideBarInfoPanel {...modifiedProps} />;
};


const removeCanvasInfoPlugin = {
    target: 'WindowSideBarInfoPanel',
    mode: 'wrap',
    component: RemoveCanvasInfoPlugin,
};


export {removeCanvasInfoPlugin};
